import wixData from 'wix-data';
import wixWindow from 'wix-window';
import wixLocation from 'wix-location';

function popuplateYears(){
	wixData.query("eventsDatabase")
		.limit(1000)
		.find()
		.then((results) => {
			let items = results.items;
			let years = [];
			
			items.forEach( item => {
				years.push(item.year);
			});
			
			years = [...new Set(years.sort())].reverse(); 			
			let yearsDropdown = [{"label": 'All Years', "value": 'All Years'}];			
			years.forEach( year => {
				yearsDropdown.push({"label": year, "value": year});
			});

			$w("#yearSelect").options = yearsDropdown.sort();
		})
		.catch((error) => {
			let errorMsg = error.message;
			let code = error.code;
	});
}

const options = {
	day: "numeric",
	month: "short",
	year: "numeric"
};

const linkStyleDesktop = 'margin-left: 25px; font: normal normal normal 14px/1.4em helveticaneuew01-55roma,sans-serif; text-transform: uppercase; border-bottom: 1px solid #000; color: #000; padding-bottom: 3px;';
const linkStyleMobile = 'display: inline-block;margin: 0 25px 25px 0; font: normal normal normal 10px/1.4em helveticaneuew01-55roma,sans-serif; text-transform: uppercase; border-bottom: 1px solid #000; color: #000; padding: 3px 0;';
const linksHolderStyleDesktop = 'text-align: right;';
const linksHolderStyleMobile = 'text-align: left !important; margin-top: 10px;';
let linkStyle = (wixWindow.formFactor === "Mobile") ? linkStyleMobile : linkStyleDesktop;
let linkHolderStyle = (wixWindow.formFactor === "Mobile") ? linksHolderStyleMobile : linksHolderStyleDesktop;
console.log('linkHolderStyle', wixWindow.formFactor);

const imageBaseUrl = 'https://static.wixstatic.com/media/';

const fieldsEvents = [
	{id: 'presentation', name: 'RSVP'},
	{id: 'pressRelease', name: 'PR'},
	{id: 'summary', name: 'SLIDES'},
	{id: 'transcript', name: 'SCRIPT'},
	{id: 'shareholderUpdate', name: 'UPDATE'},
	{id: 'asc606Reconciliations', name: 'RECON'},
	{id: 'webcast', name: 'WEBCAST'}
]

$w.onReady(function () {

	popuplateYears();

	var date = new Date();
	date.setDate(date.getDate() - 1);

	/* Query Upcoming Events */

	$w("#upcomingEvents").onItemReady( ($w, itemData, index) => {
		$w('#upcomingEventsTitle').text = itemData.title;
		$w('#upcomingEventsDateTime').text = itemData.date.toLocaleDateString("en-US", options).toUpperCase();
		
		if( $w('#titleUpcomingEvents').collapsed ){
				$w('#titleUpcomingEvents').expand();
			}
		if( $w('#upcomingEvents').collapsed ){
			$w('#upcomingEvents').expand();
		} 
		let itemFields = [];
		
		fieldsEvents.forEach( (field, index) => {
			if( itemData[field['id']]) {
				itemFields.push(fieldsEvents[index]);
			}
		});
		
		let linksHtml = [];

		itemFields.forEach( (field, index) => {
			let id = field.id.toString();
			let name = field.name.toString();

			if( itemData[id] ){
				let link = itemData[id];
				linksHtml.push(`<a class="customLink" style="${linkStyle}" href="${link}">${name}</a>`);
			}
		});
		
		linksHtml = linksHtml.join('');
		$w('#upcomingEventsButtonsHolder').html = `<div style="${linkHolderStyle}">${linksHtml}</div>`;
	});
	
	wixData.query("eventsDatabase")
		.ge("date", date)
		.descending('date')
		.find()
		.then((results) => {
			if( results.length === 0) {
				$w('#columnStrip1').collapse();
			}
			$w('#upcomingEvents').data = results.items;
		})
		.catch((error) => {
			let errorMsg = error.message;
			let code = error.code;
	});

	/* Query Archived Events */

	$w("#archivedEvents").onItemReady( ($w, itemData, index) => {
		$w("#archivedEventTitle").text = itemData.title;
		$w('#archivedEventDateTime').text = itemData.date.toLocaleDateString("en-US", options).toUpperCase();
		
		if( $w("#archivedEvents").collapsed ){
			$w("#archivedEvents").expand();
		} 
		let itemFields = [];
		
		fieldsEvents.forEach( (field, index) => {
			if( itemData[field['id']]) {
				itemFields.push(fieldsEvents[index]);
			}
		});
		
		let linksHtml = [];

		itemFields.forEach( (field, index) => {
			let id = field.id.toString();
			let name = field.name.toString();
			
			if( itemData[id] ){
				let link = itemData[id];
				linksHtml.push(`<a class="customLink" style="${linkStyle}" href="${link}">${name}</a>`);
			}
		});
		
		linksHtml = linksHtml.join('');
		$w('#archivedButtonsHolder').html = `<div style="${linkHolderStyle}">${linksHtml}</div>`;
	});
	
	wixData.query("eventsDatabase")
		.ge("date", date)
		.descending('date')
		.find()
		.then((results) => {
			$w('#upcomingEvents').data = results.items;
		})
		.catch((error) => {
			let errorMsg = error.message;
			let code = error.code;
	});

	wixData.query("eventsDatabase")
		.lt("date", date)
		.descending('date')
		.find()
		.then((results) => {
			$w('#archivedEvents').data = results.items;
		})
		.catch((error) => {
			let errorMsg = error.message;
			let code = error.code;
	});
});

/* Query Archived Events */

export function yearSelect_change(event) {

	$w("#archivedEvents").onItemReady( ($w, itemData, index) => {
		$w("#archivedEventTitle").text = itemData.title;
		console.log('itemData.date', itemData.date);
		$w('#archivedEventDateTime').text = itemData.date.toLocaleDateString("en-US", options).toUpperCase();
		
		if( $w("#archivedEvents").collapsed ){
			$w("#archivedEvents").expand();
		}

		let itemFields = [];
		
		fieldsEvents.forEach( (field, index) => {
			if( itemData[field['id']]) {
				itemFields.push(fieldsEvents[index]);
			}
		});
		
		let linksHtml = [];

		itemFields.forEach( (field, index) => {
			let id = field.id.toString();
			let name = field.name.toString();
			
			if( itemData[id] ){
				let link = itemData[id];
				linksHtml.push(`<a class="customLink" style="${linkStyle}" href="${link}">${name}</a>`);
			}
		});
		
		linksHtml = linksHtml.join('');
		$w('#archivedButtonsHolder').html = `<div style="${linkHolderStyle}">${linksHtml}</div>`;
	});

	if( event.target.value === 'All Years' ) {
		
		wixData.query("eventsDatabase")
			.limit(1000)
			.descending('date')
			.find()
			.then((results) => {
				console.log('results', results);
				$w('#archivedEvents').data = results.items;
			})
			.catch((error) => {
				let errorMsg = error.message;
				let code = error.code;
		});
	}else{
		
		wixData.query("eventsDatabase")
			.eq("year", event.target.value)
			.limit(1000)
			.descending('date')
			.find()
			.then((results) => {
				$w('#archivedEvents').data = results.items;
			})
			.catch((error) => {
				let errorMsg = error.message;
				let code = error.code;
		});
	}
}